import { matchPath } from 'react-router-dom';
import { EVENT_DETAIL_PATH } from '../config/routes';

function readTrackedEventKeyFromPathname(pathname) {
    if (typeof pathname !== 'string') {
        return null;
    }

    const match = matchPath(pathname, { path: EVENT_DETAIL_PATH, exact: true });

    return match === null ? null : match.params.slug;
}

export default readTrackedEventKeyFromPathname;
